import { Etapa } from 'src/app/shared/model/gestion-proyectos/etapa/etapa';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ConsultaList } from '../shared/model/core/ConsultaList.model';
import { incidenciaDetalleQABean } from '../shared/model/incidencias/incidenciaDetalleQABean.model';
import { Proyectos } from '../shared/model/incidencias/proyectos.model';
import { EtapaProyectoBean } from '../shared/model/incidencias/etapaproyecto.model';
import { Incidencias } from '../shared/model/incidencias/incidencia.model';
import { map } from 'rxjs/operators';
import { UrlConstantes } from '../utilerias/constantes/urlconstantes';
import { VersionBean } from '../shared/model/incidencias/version.model';
import { EvidenciaBean } from '../shared/model/incidencias/evidenciaBean.model';
import { Graficas } from '../graficas/gestionGraficas/graficas.model';
import { Observable } from 'rxjs';
import { Base } from '../shared/model/core/base.model';
import { Usuario } from '../shared/model/security/usuario.model';
import { ReporteIncidencia } from '../shared/model/incidencias/reporteIncidencia.model';
import { ResolucionEstado } from './resolucion-version.util';

const API_URL = environment.apiUrl;
@Injectable({ providedIn: 'root' })
export class IncidenciasService {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  consultatiposdefiltros() {
    return this.http.get(
      API_URL + 'controller/consultatiposFiltrosEnum.do',
      {}
    ); // Consulta tipos de filtros
  }

  
  consultaReporte(beanversion: VersionBean) {
    return this.http.post<ConsultaList<ReporteIncidencia>>(
      API_URL + 'controller/consultaReporteIncidencia.do',
      beanversion,
      {}
    ); // Consulta gestion de incidencias con paginacion
  }

  consultaCincoIncidencia(beanversion: VersionBean) {
    return this.http.post<ConsultaList<Incidencias>>(
      API_URL + 'controller/consultaCincoIncidencia.do',
      beanversion,
      {}
    ); // Consulta gestion de incidencias con paginacion
  }

  consultaproyectos(beanproyectos: Proyectos) {
    return this.http.post<ConsultaList<Proyectos>>(
      API_URL + 'controller/consultaProyectosXFiltro.do',
      beanproyectos,
      {}
    ); // Consulta gestion de incidencias con paginacion
  }

  consultaProyectosClienteIncidencias() {
    return this.http.post<ConsultaList<Proyectos>>(
      UrlConstantes.consultaProyectosClienteIncidencias,
      {},
      {}
    );
  }

  consultarIncidenciasClienteDashboard(filtro: ConsultaList<Incidencias>) {
    return this.http.post<ConsultaList<Incidencias>>(
      UrlConstantes.consultaIncidenciasClienteDashboard,
      filtro,
      {}
    );
  }

  guardarIncidenciaCliente(incidencia: Incidencias) {
    return this.http.post<Incidencias>(
      UrlConstantes.guardaIncidenciaCliente,
      incidencia,
      {}
    );
  }

  consultarBandejaIncidenciasCliente(filtro: ConsultaList<Incidencias>) {
    return this.http.post<ConsultaList<Incidencias>>(
      UrlConstantes.consultaBandejaIncidenciasCliente,
      filtro,
      {}
    );
  }

  importarIncidenciaCliente(idIncidenciaCliente: number) {
    const request = new Incidencias();
    request.id = idIncidenciaCliente;
    return this.http.post<Incidencias>(
      UrlConstantes.importarIncidenciaClienteQA,
      request,
      {}
    );
  }

  consultaUsuario(bean: Usuario) {
    return this.http.post<Usuario>(
     UrlConstantes.CONSULTAUSUARIOINCIDENCIA,
     bean,
      {}
    ); // Consulta el nombre de usuario
  }
 


  consultaproyectosXId(beanproyectos: Proyectos) {
    return this.http.post<Proyectos>(
      API_URL + 'controller/consultaProyectosXID.do',
      beanproyectos,
      {}
    ); // Consulta gestion de incidencias con paginacion
  }
  
  consultaetapas(id: number) {
    return this.http.post<ConsultaList<Etapa>>(
      API_URL + 'controller/obtenerEtapas.do',
      id,
      {}
    ); // Consulta gestion de incidencias con paginacion
  }
  consultarIncidencias(beanincidencias: ConsultaList<Incidencias>) {
    return this.http.post<ConsultaList<Incidencias>>(
      API_URL + 'controller/consultaIncidenciasXFiltroQA.do',
      beanincidencias,
      {}
    ); // Consulta gestion de incidencias con paginacion
  }
  consultaPrioridad() {
    return this.http.get(API_URL + 'controller/consultapriodidad.do', {}); // Consulta gestion de incidencias con paginacion
  }
  consultaVersion(beanversion: EtapaProyectoBean) {
    return this.http.post<ConsultaList<VersionBean>>(
      API_URL + 'controller/consultaVersionesProyecto.do',
      beanversion,
      {}
    ); // Consulta gestion de incidencias con paginacion
  }

  searchVersion(id: string) {
    return this.http.post<VersionBean>(UrlConstantes.searchVersion, id, {});
  }

  guardaIncidencia(beanIncidenciaQA: Incidencias) {
    return this.http.post<Incidencias>(
      UrlConstantes.guardaIncidencia,
      beanIncidenciaQA,
      {}
    );
  }
  detalleIncidencia(detalle: Incidencias) {
    return this.http.post<ConsultaList<incidenciaDetalleQABean>>(
      UrlConstantes.consultaDetalleQA,
      detalle
    ); //Consulta DEtalles de Incidencia
  }

  /**
   * Una incidencia QA por su id, para abrir el detalle desde un enlace directo.
   * Si no existe o es de otro tenant el backend responde 200 sin cuerpo: null.
   */
  consultaIncidenciaXId(id: number) {
    return this.http.post<Incidencias | null>(
      UrlConstantes.consultaIncidenciaQAXId,
      { id }
    );
  }

  /**
   * INCIDENCIA_RESOLUCION_ESTADO (T3b): si la incidencia se resuelve sin
   * elegir versión, si su resolución espera versión y en cuál se entregó.
   * Un rechazo viaja en pCodRetorno/pMensaje; sin sesión, 401.
   */
  estadoResolucion(idIncidencia: number): Observable<ResolucionEstado> {
    return this.http.post<ResolucionEstado>(
      UrlConstantes.INCIDENCIA_RESOLUCION_ESTADO,
      { idIncidencia }
    );
  }

  public uploadEvidencia(data: FormData) {
    return this.http.post(UrlConstantes.uploadEvidencia, data, {
        reportProgress: true,
        observe: 'events'
      })
      .pipe(
        map(event => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round((100 * event.loaded) / event.total);
              return { status: 'progress', message: progress };

            case HttpEventType.Response:
              return event.body;
            default:
              return `Unhandled event: ${event.type}`;
          }
        })
      );
  }

  public uploadEvidenciaTarea(data) {
    return this.http.post(UrlConstantes.uploadEvidencia, data, {
        reportProgress: true,
        observe: 'events'
      })
      .pipe(
        map(event => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round((100 * event.loaded) / event.total);
              return { status: 'progress', message: progress };

            case HttpEventType.Response:
              return event.body;
            default:
              return `Unhandled event: ${event.type}`;
          }
        })
      );
  }

  guardaComentario(incidenciaObject: Incidencias) {
    return this.http.post<Incidencias>(
      API_URL + 'controller/guardaDetalles.do',
      incidenciaObject
    );
  }

  condultaImagenEvidencia(imagen: EvidenciaBean) {
    return this.http.post(UrlConstantes.consultaImagenEvidencia, imagen, {
      responseType: 'arraybuffer'
    }); //Consulta Imagen Evidencia ImageData
  }

  descargaEvidencia(imagen: EvidenciaBean) {
    return this.http.get(
      UrlConstantes.descargaEvidencia +
        '/' +
        imagen.nombre +
        '/' +
        imagen.idProyecto +
        '/' +
        imagen.idIncidencia,
      { responseType: 'arraybuffer' }
    ); //Descarga Evidencia
  }
  consultaIncidenciaXs() {
    return this.http.post<Graficas[]>(API_URL + 'controller/graficarIncidenciaXs.do', {}); // Consulta tipos de filtros
}
  consultaIncidenciaXd() {
  return this.http.post<Graficas[]>(API_URL + 'controller/graficarIncidenciaXd.do', {}); // Consulta tipos de filtros
}
  consultaIncidenciaXp() {
  return this.http.post<Graficas[]>(API_URL + 'controller/graficarIncidenciaXp.do', {}); // Consulta tipos de filtros
}
consultaIncidenciaXPE(bean: Incidencias) {
  return this.http.post<Graficas[]>(API_URL + 'controller/consultaGraficaXpe.do',bean,{}); // Consulta tipos de filtros
}
consultaIncidenciaXPEE(bean: Incidencias) {
  return this.http.post<Graficas[]>(API_URL + 'controller/consultaGraficaXpee.do',bean,{}); // Consulta tipos de filtros
}

 /**
    * Obtiene el elemento correspondiente al parametro indicado
    * @param url
    * @param elemento
    */
   public obtenerElementoPorCampo(url: string, elemento: any): Observable<any> {
    const httpParams = new HttpParams().set('elemento', elemento);
    return this.http.get<any>(url, {
        params: httpParams,
        responseType: 'json'
    });
}

/**
    * Obtiene el elemento correspondiente al parametro indicado
    * @param url
    * @param elemento
    */
   public obtenerElementoPorCampoApi(url: string, elemento: any): Observable<any> {
    const httpParams = new HttpParams().set('elemento', elemento);
    return this.http.get<any>(API_URL + url, {
        params: httpParams,
        responseType: 'json'
    });
}

/**
     * Obtiene el elemento correspondiente al parametro indicado
     * @param url
     * @param elemento
    */
   public obtenerElementoPorCampoPost(url: string, elemento: any): Observable<any> {
    return this.http.post<any>(url, elemento, {
        responseType: 'json'
    });
}


marcarVistoNotificacion(req: any) {
  return this.http.post<any>(API_URL + UrlConstantes.MARCAR_VISTO_NOTIFICACION, req);
}

marcarVistoTodas(req: any) {
  return this.http.post<any>(API_URL + UrlConstantes.MARCAR_VISTO_TODAS, req);
}

consultaTipo() {
  return this.http.get(API_URL + 'controller/consultaTipoProyecto.do', {}); // Consulta gestion de incidencias con paginacion
}

}
